import React from 'react';
import { ReviewFilterOption, RouteSection } from '../../types';
import { FilterDropdown } from './styles';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Option } from 'src/components/filter-dropdown';

export const UserReviewFilter: React.FC<UserReviewFilterProps> = ({
  route,
  reviewFilterOptions,
  defaultSelectedReviewFilter,
  onFilterChange,
}) => {
  const { t } = useAppContext();
  const options = reviewFilterOptions.filter(
    option =>
      option.distribution !== null &&
      option.distribution !== undefined &&
      option.distribution > 0
  );
  return (
    <FilterDropdown
      onFilterChange={option => onFilterChange(option, route)}
      title={t('common', 'button.show')}
      options={options}
      defaultSelected={defaultSelectedReviewFilter}
    />
  );
};

interface UserReviewFilterProps {
  route: RouteSection;
  reviewFilterOptions: ReviewFilterOption[];
  defaultSelectedReviewFilter: ReviewFilterOption;
  onFilterChange: (option: Option, route?: RouteSection | undefined) => void;
}
